import { render, staticRenderFns } from "./CompanyTestimonial.vue?vue&type=template&id=4c03fd06&scoped=true&"
import script from "./CompanyTestimonial.vue?vue&type=script&lang=js&"
export * from "./CompanyTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTestimonial.vue?vue&type=style&index=0&id=4c03fd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c03fd06",
  null
  
)

export default component.exports